// Regra do estorno na comissão.
//
// Junho/2026 foi mês de teste da carga de estornos da Claro Control.
// A vigência do estorno na comissão começa em 2026-07.
//
//  - ANTES da vigência (junho/2026 = teste): o estorno NÃO conta em nada — é
//    removido do cálculo. Continua registrado na aba ESTORNO / "Estornos do mês".
//  - A PARTIR da vigência (julho/2026+): o estorno NÃO reduz faturamento (R$),
//    ele só DESCONTA a quantidade de meta. Por isso zeramos o `subtotal`
//    (faturamento) e mantemos a `quantidade` negativa, que deflaciona o count da
//    meta (altas/fibras/tt/mp/migração) sem baixar a faixa/faturamento.
export const ESTORNO_VIGENCIA_INICIO = '2026-07';

export function estornoValeNaComissao(mesTrabalho: string): boolean {
  return (mesTrabalho || '') >= ESTORNO_VIGENCIA_INICIO;
}

export function ajustarEstornoComissao<
  T extends { coluna_atual?: string | null; subtotal?: number | null }
>(itens: T[], mesTrabalho: string): T[] {
  // Antes da vigência: estorno fora do cálculo.
  if (!estornoValeNaComissao(mesTrabalho)) {
    return (itens || []).filter((i) => (i.coluna_atual || '') !== 'ESTORNO');
  }
  // Na vigência: estorno não mexe no faturamento (subtotal=0), só na quantidade.
  return (itens || []).map((i) =>
    (i.coluna_atual || '') === 'ESTORNO' ? ({ ...i, subtotal: 0 } as T) : i
  );
}

// Alias mantido para os call-sites já existentes (mesma lógica acima).
export const removerEstornoNaoVigente = ajustarEstornoComissao;

